"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNull = exports.isPair = exports.isProcedure = exports.isSymbol = exports.isString = exports.isBool = exports.isNumber = void 0;
const sExpression_1 = require("../sExpression");
exports.isNumber = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'number?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'number')
};
exports.isBool = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'boolean?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'boolean')
};
exports.isString = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'string?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'string')
};
exports.isSymbol = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'symbol?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'symbol')
};
exports.isProcedure = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'procedure?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'procedure')
};
exports.isPair = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'pair?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'pair')
};
exports.isNull = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'null?',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => sExpression_1.makeBool(args[0].type === 'empty list')
};
//# sourceMappingURL=typePredicates.js.map